export class TabClusterComuniModel {
  desClusterComuni:	string
  idClusterComuni: number  
}